"use client"

import type { ReactNode } from "react"

import { cn } from "@/lib/utils"
import { ColourEnum } from "@/types/contents/colours"

/**
 * ShadowWrapper component
 * @param children - The children to render.
 * @param colour - The colour of the shadow (yellow, mint, cream, navy).
 * @param className - The class name.
 * @returns The ShadowWrapper component.
 */
export function ShadowWrapper({
  children,
  colour = ColourEnum.yellow,
  className,
}: {
  children: ReactNode
  colour?: ColourEnum
  className?: string
}) {
  return (
    <div className={cn("group", className)}>
      <div
        aria-hidden="true"
        className={cn(
          colour,
          "pointer-events-none absolute inset-0 translate-x-1 translate-y-1",
          "rounded-2xl opacity-0 transition-all duration-200",
          "h-auto w-auto max-sm:hidden sm:group-hover:opacity-100",
        )}
      />
      {children}
    </div>
  )
}
